import { useQuery } from '@tanstack/react-query'

import { getLighterWithdrawalDelay } from './lighterAdaptedWallet'

/**
 * Lighter's live L2→L1 bridge delay, in seconds, or `undefined` until it loads.
 * - Shared by web and native so the two never quote the same bridge differently,
 *   and so both read one cache entry.
 * - An unusable value reads as `undefined`, not `0`: callers fall back to the
 *   historical estimate rather than promising instant finality.
 */
export function useLighterWithdrawalDelaySeconds({
  enabled = true,
}: {
  /** Off for a host that configured no Lighter — it must not reach Lighter's API. */
  enabled?: boolean
} = {}): number | undefined {
  const { data } = useQuery({
    queryKey: ['lighterWithdrawalDelay'],
    queryFn: getLighterWithdrawalDelay,
    enabled,
    staleTime: 60_000,
    retry: 2,
  })
  const seconds = data?.seconds
  if (seconds === undefined || !Number.isFinite(seconds) || seconds <= 0) {
    return undefined
  }
  return seconds
}
